import React, { createContext, useContext, useState, useEffect, useCallback, useRef } from 'react';
import { useAuth } from './AuthContext';

// Provee el conteo global de mensajes no leídos y lo mantiene fresco con
// polling cada 15s (sin WebSocket en este ciclo). Un solo poller compartido
// por toda la app: el badge del header y el del perfil leen de aquí, así no
// se multiplican las peticiones.
const POLL_MS = 15 * 1000;
const Ctx = createContext({ unreadCount: 0, refreshUnread: () => {}, setUnreadCount: () => {} });

export function MessagesProvider({ children }) {
  const { user, getUnreadCount } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);
  const timerRef = useRef(null);

  const refreshUnread = useCallback(async () => {
    if (!user) return;
    try {
      const count = await getUnreadCount();
      setUnreadCount(Number.isFinite(count) ? count : 0);
    } catch { /* red caída: conservamos el último valor conocido */ }
  }, [user, getUnreadCount]);

  useEffect(() => {
    if (!user) { setUnreadCount(0); return; }
    refreshUnread();
    timerRef.current = setInterval(refreshUnread, POLL_MS);
    // Al volver a la pestaña, refrescamos de inmediato (no esperamos 15s).
    const onVisible = () => { if (document.visibilityState === 'visible') refreshUnread(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(timerRef.current);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [user, refreshUnread]);

  return (
    <Ctx.Provider value={{ unreadCount, refreshUnread, setUnreadCount }}>
      {children}
    </Ctx.Provider>
  );
}

export const useMessages = () => useContext(Ctx);
